import { useMemo } from 'react'
import { useAuth0 as useInternalAuth0 } from '@auth0/auth0-react'

// TODO: namespace を正しいものに置き換える（現在は仮で Auth0 の Actions 上で使用している namespace）
const NAMESPACE = 'https://my-app.example.com'

interface Auth0User {
  email: string
  email_verified: boolean
  // TODO: namespace を正しいものに置き換える
  'https://my-app.example.com/org_name': string
  'https://my-app.example.com/org_display_name': string
  name: string
  nickname: string
  org_id: string
  picture: string
  sub: string
  updated_at: string
}

export interface User
  extends Omit<
    Auth0User,
    | 'https://my-app.example.com/org_name'
    | 'https://my-app.example.com/org_display_name'
    | 'email_verified'
    | 'org_id'
    | 'updated_at'
  > {
  emailVerified: boolean
  orgDisplayName: string
  orgName: string
  orgId: string
  updatedAt: string
}

export interface UseAuth0Result
  extends Omit<ReturnType<typeof useInternalAuth0>, 'user'> {
  user?: User
}

export const useAuth0 = (): UseAuth0Result => {
  const { user: auth0User, ...rest } = useInternalAuth0<Auth0User>()
  const user = useMemo(() => {
    if (typeof auth0User === 'undefined') return undefined

    const {
      email_verified: emailVerified,
      org_id: orgId,
      updated_at: updatedAt,
      ...rest
    } = auth0User

    const orgNameKey = `${NAMESPACE}/org_name`
    const orgName = rest[orgNameKey]
    delete rest[orgNameKey]

    const orgDisplayNameKey = `${NAMESPACE}/org_display_name`
    const orgDisplayName = rest[orgDisplayNameKey]
    delete rest[orgDisplayNameKey]

    return {
      ...rest,
      emailVerified,
      orgDisplayName,
      orgName,
      orgId,
      updatedAt,
    }
  }, [auth0User])

  return {
    user,
    ...rest,
  }
}

export { withAuthenticationRequired, Auth0Context } from '@auth0/auth0-react'
export { Auth0Provider } from './auth0-provider'
